var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_737_8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 25.5,
    r: 25.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.75 36.8333H18.25C17.8058 36.8333 17.4375 36.465 17.4375 36.0208C17.4375 35.5767 17.8058 35.2083 18.25 35.2083H37.75C38.1942 35.2083 38.5625 35.5767 38.5625 36.0208C38.5625 36.465 38.1942 36.8333 37.75 36.8333Z",
    fill: "#21A6E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6071 16.7718C33.5054 14.6701 31.4471 14.616 29.2912 16.7718L27.9804 18.0826C27.8721 18.191 27.8287 18.3643 27.8721 18.516C28.6954 21.3868 30.9921 23.6835 33.8629 24.5068C33.9062 24.5176 33.9496 24.5284 33.9929 24.5284C34.1121 24.5284 34.2204 24.4851 34.3071 24.3984L35.6071 23.0876C36.6796 22.026 37.1996 20.9968 37.1996 19.9568C37.2104 18.8843 36.6904 17.8443 35.6071 16.7718Z",
    fill: "#21A6E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9112 25.4917C31.597 25.34 31.2937 25.1884 31.0012 25.015C30.7628 24.8742 30.5353 24.7225 30.3078 24.56C30.1237 24.4409 29.907 24.2675 29.7012 24.0942C29.6795 24.0834 29.6037 24.0184 29.517 23.9317C29.1595 23.6283 28.7587 23.2383 28.4012 22.805C28.3687 22.7833 28.3145 22.7075 28.2387 22.61C28.1303 22.48 27.9462 22.2633 27.7837 22.0142C27.6537 21.8517 27.502 21.6133 27.3612 21.375C27.1878 21.0825 27.0362 20.79 26.8845 20.4867C26.8615 20.4375 26.8393 20.3886 26.8179 20.3399C26.658 19.9788 26.187 19.8733 25.9079 20.1525L19.702 26.3584C19.5612 26.4992 19.4312 26.77 19.3987 26.9542L18.8137 31.1034C18.7053 31.84 18.9112 32.5334 19.3662 32.9992C19.7562 33.3784 20.2978 33.5842 20.8828 33.5842C21.0128 33.5842 21.1428 33.5734 21.2728 33.5517L25.4328 32.9667C25.6278 32.9342 25.8987 32.8042 26.0287 32.6634L32.2267 26.4653C32.508 26.1841 32.4019 25.7015 32.0362 25.5454C31.995 25.5279 31.9533 25.5099 31.9112 25.4917Z",
    fill: "#21A6E9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_737_8",
    x: 0,
    y: 0,
    width: 55,
    height: 55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_737_8"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_737_8",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPEdit);
export default __webpack_public_path__ + "static/media/p-edit.21956865054aa7bc09154e0d89a066f3.svg";
export { ForwardRef as ReactComponent };